/**
 * Source of truth for the built-in pledges. Both the live <Pledges/>
 * carousel and the classroom-detail Pledges settings tab read from
 * here, so the toggle UI and the live order stay in sync.
 *
 * The live page filters this list by the per-classroom enabled set
 * (see `enabledPledgesStorage.ts`); the settings panel writes that set.
 */

export interface Pledge {
  key: string;
  title: string;
  body: string;
}

export const ALL_PLEDGES: readonly Pledge[] = [
  {
    key: 'allegiance',
    title: 'Pledge of Allegiance',
    body: `I pledge allegiance to the Flag\nof the United States of America,\nand to the Republic for which it stands,\none Nation under God, indivisible,\nwith liberty and justice for all.`,
  },
  {
    key: 'christian-flag',
    title: 'Christian Flag Pledge',
    body: `I pledge allegiance to the Christian flag,\nand to the Savior for whose kingdom it stands;\none brotherhood, uniting all true Christians,\nin service and in love.`,
  },
  {
    key: 'bible',
    title: 'Bible Pledge',
    body: `I pledge allegiance to the Bible,\nGod's Holy Word.\nI will make it a lamp unto my feet\nand a light unto my path,\nI will hide its words in my heart\nthat I might not sin against God.`,
  },
];

export const ALL_PLEDGE_KEYS: readonly string[] = ALL_PLEDGES.map((p) => p.key);

/**
 * Default enabled-pledges for new classrooms (and for any classroom
 * that has never had its toggles touched). Just the Pledge of
 * Allegiance — schools that want the Christian Flag / Bible pledges
 * can opt in on the classroom's Pledges settings tab.
 */
export const DEFAULT_ENABLED_PLEDGE_KEYS: readonly string[] = ['allegiance'];
